import React, {Component} from 'react';
import './styles.css';
import CardHelper from "../../helpers";
import { Dates } from '../../../../packages/dates';
import EpgPersistence from '../../../../AAF/Nepg/EpgPersistence';
import Utils from '../../../../utils/Utils';
import { getCoverStyle, isPS4Platform, clearCoverRef } from '../ps4ImageUtils';

const _isPS4 = isPS4Platform();

class CardLiveChannel extends Component{
  constructor(props) {
    super(props);
    this.state = {
      showActions: props.showActions,
      imageReady: !_isPS4,
    };
    this.hasPlayerIcon = props.hasPlayerIcon;
    this.cover = props.cover;
    this.bookmark = props.bookmark;
    this.title = props.title;
    this.onDeleteAction = props.onDeleteAction;
    this.data = props.data;
    this.badges = props.badges;
    this.id = props.id;
    this._coverRef = null;
    this._loadTimer = null;

    this._setCoverRef = this._setCoverRef.bind(this);

    // Cache de elementos JSX
    this._cachedCoverStyle = null;
    this._prevCoverUrl = undefined;
    this._prevImageReady = undefined;
  }

  componentDidMount() {
    if (!this.state.imageReady) {
      this._loadTimer = setTimeout(this._onImageReady, _isPS4 ? 200 : 150);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.showActions !== this.state.showActions) {
      this.setState({ showActions: nextProps.showActions });
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      this.state.showActions !== nextState.showActions ||
      this.state.imageReady !== nextState.imageReady
    );
  }

  componentWillUnmount() {
    if (this._loadTimer) {
      clearTimeout(this._loadTimer);
      this._loadTimer = null;
    }
    clearCoverRef(this._coverRef);
    this._coverRef = null;
    this._cachedCoverStyle = null;
  }

  _onImageReady = function() {
    this.setState({ imageReady: true });
  }.bind(this);

  _setCoverRef(el) {
    this._coverRef = el;
  }

  render() {
    const data = this.data;
    const needsOffset = EpgPersistence.needsOffset();
    const dateStart = needsOffset
      ? new Dates().unix(data.unix_begin).utcOffset(needsOffset, false).format('HH:mm')
      : new Dates().unix(data.unix_begin).format('HH:mm');
    const dateEnd = needsOffset
      ? new Dates().unix(data.unix_end).utcOffset(needsOffset, false).format('HH:mm')
      : new Dates().unix(data.unix_end).format('HH:mm');
    const pgress = CardHelper.getTimeProgress(data.unix_begin, data.unix_end);
    const channelNumber = data.channelNumber || '';
    const channelName = data.channelName || '';
    const title = data.title;
    const titleChannel = CardHelper.fillZeroLeft(channelNumber, 4) + ' | ' + channelName;
    const size = 22;
    const sizeTitle = 21;
    const titleFinalChannel = (typeof titleChannel === 'string' && titleChannel.length > size) ? Utils.cutPlayerString(titleChannel, size) : titleChannel;
    const finalTitle = (typeof title === 'string' && title.length > sizeTitle) ? Utils.cutPlayerString(title, sizeTitle) : title;

    // Actualizar cover style solo si cambió
    const coverUrl = data.cover;
    const imageReady = this.state.imageReady;
    if (coverUrl !== this._prevCoverUrl || imageReady !== this._prevImageReady) {
      this._prevCoverUrl = coverUrl;
      this._prevImageReady = imageReady;
      this._cachedCoverStyle = getCoverStyle(coverUrl, imageReady);
    }

    return (
      <div className={'card card-livechannel'}>
        <div className={'card-container'}>
          {this.cover !== '' &&
          <div
            ref={this._setCoverRef}
            className='card-cover'
            style={this._cachedCoverStyle}
          />
          }
          {CardHelper.createProgressBar(pgress, this.hasPlayerIcon)}
          {CardHelper.createBadge(this.badges)}
          {CardHelper.createPlayerIcon()}
        </div>
        <div className={'card-info'}>
          <div className={'card-info_container'}>
            <p className={'title'}>{finalTitle}</p>
            <p className={'description'}>{titleFinalChannel}</p>
            <p className={'status'}>
              <i className="fa fa-television" aria-hidden="true"></i>
              <span className="badge badge-color">
           EN VIVO
          </span>
            </p>
            <p className={'time'}>{dateStart} - {dateEnd} {this.state.showActions && CardHelper.createDeleteIcon()}</p>
          </div>
        </div>
      </div>
    );
  }
}

export default CardLiveChannel;



// WEBPACK FOOTER //
// ./src/components/CardNew/cardTypes/CardLiveChannel/index.js